import { LMkeywords, ListingKeywordsData } from "./types";

export const parseAPILMkeywords = (apiLMkeywords: ListingKeywordsData): LMkeywords => {
  return {
    keywordsData: apiLMkeywords,
  }
}
